import React from 'react';
import s from '@Pages/Detail/styles/PriceBox.module.css';
import { MembershipPricesProps } from '@Pages/Detail/props';
import { URL } from '@Pages/url';
import MailSVGIcon from '@Components/svg_icon/mail';
import { calcTotalBudgetWithCommission, calcCommission, priceFormat } from '@Util/util';

export const NotInitialPiceBox = (props: MembershipPricesProps) => {
    const priceUnit = props.isJpy ? '万' : 'THB';
    const totalBudget =
        calcTotalBudgetWithCommission(props.membership.totalBudget) && props.membership.numberOfSellingOffers > 0
            ? `〜${priceFormat(
                  calcTotalBudgetWithCommission(props.membership.totalBudget, props.membership.sellingPrice),
                  priceUnit
              )}`
            : '-';
    return (
        <>
            <div className={s.course_prices}>
                <p className={s.course_price}>
                    <span className={s.sell_price_tag}>売値</span>
                    希望最安値：
                    {props.membership.isAsk ? (
                        <span className={s.price}>ご相談</span>
                    ) : (
                        <>
                            <span className={s.price}>{props.membership.sellingPrice || '-'}</span>
                            {priceUnit}
                        </>
                    )}
                    <span className={s.bid_count}>({props.membership.numberOfSellingOffers}件)</span>
                </p>
                <div className={s.border} />
                <p className={s.course_price}>
                    <span className={s.buy_price_tag}>買値</span>
                    希望最高値：
                    {props.membership.isAsk ? (
                        <span className={s.price}>ご相談</span>
                    ) : (
                        <>
                            <span className={s.price}>{props.membership.buyingPrice || '-'}</span>
                            {priceUnit}
                        </>
                    )}
                    <span className={s.bid_count}>({props.membership.numberOfBuyingOffers}件)</span>
                </p>
            </div>
            <div className={s.budget_info}>
                <div className={s.budget_info_box}>
                    <p className={s.budget_info_text}>
                        <span className={s.icon_round} />
                        購入総額概算：
                        {props.membership.isAsk ? (
                            <span className={s.budget}>ご相談</span>
                        ) : (
                            <span className={s.budget}>{totalBudget}</span>
                        )}
                    </p>
                    <p className={s.budget_info_text}>
                        <span className={s.icon_round} />
                        年会費：
                        <span className={s.annual_fee}>
                            {props.membership.annualFee || '-'}
                            {props.isJpy ? '円' : 'THB'}
                        </span>
                    </p>
                </div>
                <p className={s.budget_mini_info}>
                    (名義書換料: {props.membership.registrationFee || '-'}
                    {props.isJpy ? '万円' : 'THB'}/入会預託金: {props.membership.deposit || '-'}
                    {priceUnit}
                    /手数料: {priceFormat(calcCommission(props.membership.sellingPrice), priceUnit)})
                </p>
                {props.playguideUrl && (
                    <div className={s.playguide_link_box}>
                        <a
                            href={props.playguideUrl}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={s.playguide_link}
                        >
                            プレイガイドはこちら
                        </a>
                    </div>
                )}
            </div>
            <div className={s.info_footer}>
                <div className={s.info_caution}>
                    <p>※{props.membership.version}現在(税込価格)</p>
                    <p>※総額＝売値＋名義書換料＋入会預託金+手数料</p>
                </div>
                <div className={s.send_mail_button_box}>
                    <a className={s.send_mail_button} href={`${URL.PERIODIC_MAIL}?course_id=${props.courseId}`}>
                        <MailSVGIcon />
                        相場定期メールを送る
                    </a>
                </div>
            </div>
        </>
    );
};

export default NotInitialPiceBox;
